var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-info mt-4",attrs:{"role":"alert"}},[_vm._v(" No data yet. "),_c('a',{attrs:{"href":"/"}},[_vm._v("Upload a CSV file")]),_vm._v(" first, or try it with the "),_c('a',{attrs:{"href":"/raw_data.csv","download":""}},[_vm._v("sample data")]),_vm._v(". ")])
}]

export { render, staticRenderFns }